/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";
import { Database } from "../../../server/supabase/types/database-definitions";

export type OutboxRecipient = Database["public"]["Views"]["outbox_recipients"]["Row"];

export class SupabaseOutboxRecipientsService extends SupabaseServiceView<"outbox_recipients"> {
  table = "outbox_recipients" as const;
}
